import { createUseStyles } from 'react-jss';
import { CmsWrenchTheme } from '~app/styles/cmsTheme';

const useStyles = createUseStyles(({ type, breakpoints, spacing, brandColors }: CmsWrenchTheme) => {
  const mediaQueryMinScreenXL = `@media (min-width: ${breakpoints.xl}px)`;
  const mediaQueryMinScreenLG = `@media (min-width: ${breakpoints.lg}px)`;

  return {
    card: {
      border: `2px solid ${brandColors.neutral.offWhite}`,
      borderRadius: '24px',
      padding: '24px',
      maxWidth: '390px',
      margin: ' 8px auto',
      [mediaQueryMinScreenLG]: {
        padding: '12px',
        margin: '0 8px',
      },
      [mediaQueryMinScreenXL]: {
        padding: '24px',
      },
    },
    subheader: {
      minHeight: '72px',
    },
    imageContainer: {
      width: '100%',
      height: '200px',
      objectFit: 'contain',
      objectPosition: 'center',
    },
  };
});

export default useStyles;
